import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import Header from "../../common/Header/Header";
import Sidebar from "../../common/Sidebar/Sidebar";
import Footer from "../../common/Footer/Footer";
import styles from "./AuthLayout.module.scss";

const AuthLayout = (props) => {
  const [show, setShow] = useState(false);
  const location = useLocation();
  const handleShow = () => {
    document.body.clientWidth < 1199 && setShow(!show);
  };

  window.onresize = () => {
    if (document.body.clientWidth > 1200) {
      setShow(false);
    }
  };

  useEffect(() => {
    if (document.body.clientWidth > 1200) {
      setShow(false);
    }
  }, []);

  useEffect(() => {
    // if sidebar is open disable body scroll
    document.body.style.overflow = show ? "hidden" : "visible";
  }, [show]);

  useEffect(() => {
    document.body.style.background = "#FAFCFE";
    window.scrollTo(0, 0);
  }, [location]);
  return (
    <main className={styles.auth_layout}>
      <Header show={show} handleShow={handleShow} />
      <Sidebar show={show} handleShow={handleShow} />
      <div className={styles.auth_inner}>
        <Container>
          <div className={styles.auth_content}>
            {props.children}
            <Footer />
          </div>  
        </Container>
      </div>
    </main>
  );
};

export default AuthLayout;
